<template>
    <footer>
        <div class="container">
            <div class="footer">
                <div class="footer__left">
                    <h5><span>Retail Only</span> i Sverige AB</h5>
                    <p>Kvartsgatan 8</p>
                    <p>749 40 Enköping</p>
                    <div class="footer__left-info">
                        <div class="footer__left-info-email">
                            <img
                                src="../../assets/icons/footer-email-icon.svg"
                            />
                            <span>info@retailonly.se</span>
                        </div>
                        <div class="footer__left-info-org">
                            <img src="../../assets/icons/footer-org-icon.svg" />
                            <span>Org.nr 559155-1790</span>
                        </div>
                        <div class="footer__left-info-bank">
                            <img
                                src="../../assets/icons/footer-bank-icon.svg"
                            />
                            <span>Handelsbanken 126-3441</span>
                        </div>
                    </div>
                </div>
                <div class="footer__mid">
                    <img
                        src="../../assets/images/footer-tagline.svg"
                        alt="Retail Only tagline"
                    />
                </div>
                <div class="footer__right">
                    <h5>Retail Only i <span>Sociala medier</span></h5>
                    <div class="footer__right-social">
                        <a
                            href="https://www.linkedin.com/company/retail-only-i-sverige-ab/"
                            target="_blank"
                        >
                            <img
                                src="../../assets/icons/footer-linkedin-icon.svg"
                            />
                        </a>
                        <a
                            href="https://www.facebook.com/Retail-Only-465857273847638/"
                            target="_blank"
                        >
                            <img
                                src="../../assets/icons/footer-facebook-icon.svg"
                            />
                        </a>
                    </div>
                    <div class="footer__right-info">
                        <router-link to="privacy-policy"
                            >Personuppgiftspolicy</router-link
                        >
                        <p id="copyright">
                            Copyright &copy; {{ year }}, Retail Only
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </footer>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
    name: 'Footer',
    setup() {
        let year = new Date().getFullYear()

        return {
            year,
        }
    },
})
</script>

<style lang="scss" scoped>
@import '../../styles/variables';
@import '../../styles/mixins';
@import '../../styles/config';
footer {
    background-color: $footer-background-color;
    color: #fff;

    .footer {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        padding: 4rem 0;
        font-weight: 300;

        @include mQ(768px) {
            & {
                grid-template-columns: none;
                grid-template-rows: repeat(1, 1fr);
                place-items: center;
                padding: 2rem 1rem;
                text-align: center;
                gap: 2rem;
            }
        }

        p:first-of-type {
            margin-top: 0.5rem;
        }

        &__left {
            display: flex;
            flex-direction: column;
            height: 100%;

            &-info {
                margin-top: 2rem;

                @include mQ(768px) {
                    & {
                        margin-top: 1rem;
                    }
                }

                &-email,
                &-org,
                &-bank {
                    display: flex;
                    align-items: center;
                    margin-bottom: 0.5rem;

                    @include mQ(768px) {
                        & {
                            justify-content: center;
                        }
                    }

                    &:last-of-type {
                        margin-bottom: 0;
                    }

                    & > span {
                        margin-left: 0.5rem;
                    }
                }
            }
        }

        &__mid {
            place-self: center;

            @include mQ(768px) {
                & {
                    grid-row: 3 / 4;
                }
            }

            @include mQ(960px) {
                & img {
                    width: 300px;
                }
            }
        }

        &__right {
            display: flex;
            flex-direction: column;
            height: 100%;
            text-align: right;

            @include mQ(768px) {
                & {
                    grid-row: 2 / 3;
                    text-align: center;
                }
            }

            &-social {
                margin-top: 0.5rem;

                & a:first-of-type {
                    margin-right: 0.3rem;
                }

                @include mQ(900px) {
                    margin: 1rem 0 2rem 0;

                    & a:first-of-type {
                        margin-right: 0.25rem;
                    }
                }
            }

            &-info {
                margin-top: auto;

                @include mQ(768px) {
                    & {
                        justify-content: center;
                    }
                }

                a {
                    color: #fff;
                    text-decoration: underline;
                }
            }
        }
    }
}
</style>
